export const DEFAULT_AUTOHIDE_DURATION = 4000;
export const DEFAULT_DEBOUNCE_DELAY = 1000;
export const DEFAULT_TABLE_PAGE_SIZE = 10;
export const DEFAULT_ACTIVE_TAB_INDEX = 0;
export const DEFAULT_DATE_FORMAT = 'DD.MM.YYYY';
export const DATE_REQUEST_FORMAT = 'YYYY-MM-DDTHH:mm[Z]';

export const maxValueOfTotalAmount = 999999999;
